/* GreenOx enhancements. Native product-form, variant events and cart remain authoritative. */
(() => {
  if (!customElements.get('gx-sticky-buy')) {
    customElements.define('gx-sticky-buy', class extends HTMLElement {
      connectedCallback() {
        this.product = document.getElementById(`MainProduct-${this.dataset.section}`) || document.querySelector(`product-info[data-section="${this.dataset.section}"]`);
        if (!this.product) return;
        this.action = this.querySelector('[data-gx-sticky-action]');
        this.primary = this.product.querySelector('product-form button[type="submit"]');
        if (!this.primary) return;
        this.onClick = () => {
          const primary = this.product.querySelector('product-form button[type="submit"]');
          if (primary && !primary.disabled && primary.getAttribute('aria-disabled') !== 'true') primary.click();
          else this.product.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start' });
        };
        this.action.addEventListener('click', this.onClick);
        this.refresh = () => {
          const price = this.product.querySelector('[id^="price-"] .price--on-sale .price__sale .price-item--sale') || this.product.querySelector('[id^="price-"] .price__regular .price-item--regular');
          if (price) this.querySelector('[data-gx-sticky-price]').textContent = price.textContent.trim();
          const primary = this.product.querySelector('product-form button[type="submit"]');
          const unavailable = !primary || primary.disabled || primary.getAttribute('aria-disabled') === 'true';
          this.action.textContent = unavailable ? 'Zur Auswahl' : 'In den Warenkorb';
        };
        this.mutation = new MutationObserver(this.refresh);
        this.mutation.observe(this.product, { subtree: true, childList: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled'] });
        this.intersection = new IntersectionObserver(([entry]) => { this.hidden = entry.isIntersecting || entry.boundingClientRect.top > 0; }, { threshold: 0 });
        this.intersection.observe(this.primary);
        this.refresh();
      }
      disconnectedCallback() { this.intersection?.disconnect(); this.mutation?.disconnect(); this.action?.removeEventListener('click', this.onClick); }
    });
  }
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.gx-mobile-nav[open], .gx-navigation details[open]').forEach((item) => { item.open = false; item.querySelector('summary')?.focus(); });
  });
  document.addEventListener('click', (event) => {
    document.querySelectorAll('.gx-navigation details[open], .gx-mobile-nav[open]').forEach((item) => { if (!item.contains(event.target)) item.open = false; });
  });
})();
document.addEventListener('gx:delivery-error', () => {
  document.querySelectorAll('gox-lieferdatum').forEach(host => {
    if (host.querySelector('.gx-delivery-error')) return;
    const message = document.createElement('p'); message.className = 'gx-delivery-error'; message.setAttribute('role','alert');
    message.textContent = 'Der Liefertermin konnte nicht gespeichert werden. Bitte lade die Seite neu und wähle ihn erneut.'; host.append(message);
  });
});
